/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

loadStyles([{"rawString":".OverlayExample-content{position:absolute;background:#00f;color:#fff;position:absolute;bottom:0;left:0;right:0}"}]);
/* tslint:enable */
